import React from "react";
import "./MembersTable.css";
import statuteFromGroups from "../../../utils/statuteFromGroups"
import MemberRow from "./MemberRow/MemberRow";
import strings from "../../../locales/ro.json"
import arrow from "../../../assets/icons/arrow.svg"
import { UserAuth } from "../../../context/AuthContext";
import { useUI } from "../../../hooks/usePermission";

/*
users: array of users according to costelDB API
*/


/*

This is the table shown on the member management page. It shows a member's name and profile pic on one column and the user's status on the other column.

Props:

users: an array of users, as according to the CostelDB API docs.

*/

function sortUsers(users)
{
  users.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
}

function MembersTable({ users }) {
  
  // used for displaying
  const [width, setWidth] = React.useState(window.innerWidth);
  const usr = UserAuth()
  const canManage = useUI('action.users.manage');

  // used for sorting
  const [sortEvent, setSortEvent] = React.useState(0)
  const userSorted = React.useRef([...users])
  const usersRef = React.useRef([...users])
  const sortState = React.useRef(-1)
  const arrowPos1 = React.useRef(0)
  const arrowPos2 = React.useRef(0)

  // we initially sort the users by name, alphabetically
  sortUsers(users)

  // this takes initial users and copies them
  if(users.join(',') !== usersRef.current.join(','))
  {
      usersRef.current = [...users]
      userSorted.current = [...users]
  }

  // useEffect(() => {
  //   sortUsers(usersRef.current)
  // }, [])

  //we use this to check if we're on a mobile device
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  // sort by status
  function sortStatus()
  {
      userSorted.current.sort((a, b) => {
        const statusA = statuteFromGroups(a) || "";
        const statusB = statuteFromGroups(b) || "";
        if (sortState.current === 1) {
          return statusA.localeCompare(statusB);
        } else {
          return statusB.localeCompare(statusA);
        }
      });
  
      arrowPos2.current = (arrowPos2.current + 180) % 360;
      sortState.current *= -1;
      setSortEvent(sortEvent + 1);
  
  }

  // sort by name
  function sortName()
  {
      userSorted.current.sort((a, b) => {
        if (sortState.current === 1) {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
      
      arrowPos1.current = (arrowPos1.current + 180) % 360;
      sortState.current *= -1;
      setSortEvent(sortEvent + 1);

  }

  React.useEffect(() => {
    
    //dynamically resize!
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= 768;
  return (
    <div className="membersTable">
      <div className="membersTableHead">
        <div className="membersTableHeadWrapper" onClick={sortName}>
          <h2>{strings.usermanagement.tablehead[0]}</h2>
          <img src={arrow} className="arrowDownTable" style={{transform:`rotate(${arrowPos1.current}deg)`}}/>
        </div>
        <div className="membersTableHeadWrapper" onClick={sortStatus}>
          <h2>{strings.usermanagement.tablehead[1]}</h2>
          <img src={arrow} className="arrowDownTable" style={{transform:`rotate(${arrowPos2.current}deg)`}}/>
        </div>
      </div>
      {userSorted.current && userSorted.current.map((user) => {
        if(statuteFromGroups(user).localeCompare("friend") === 0 && !canManage)
          return null;
        const userID = user.email.split("@")

        return (
          <MemberRow key={user.id} photoURL={user.photoURL} name={user.name} height={isMobile ? 40 : 45} statute={statuteFromGroups(user)} userID={userID[0]} isAdmin={user.groups.includes("Admins")} />
        );
      })}
    </div>
  );
}

export default MembersTable;
